// These page types have separate events
import { deepValue } from '@corratech/pylot-utils'
import { PAGEVIEW_EVENT, PageViewEvent } from './pushPageView'
import { GTMEvent } from '../GTM'

const skipPageTypes = [
    'category',
    'product',
    'checkout',
    'order confirmation',
    'searchresults'
]

export const pushPageType = (
    preparedData?: PageViewEvent
): GTMEvent | undefined => {
    if (
        !preparedData ||
        !preparedData.event ||
        preparedData.event !== PAGEVIEW_EVENT
    ) {
        return
    }

    const pageType = deepValue(preparedData, ['pageDetails', 'pageType'], false)
    if (!pageType || skipPageTypes.includes(pageType)) {
        return
    }

    return {
        event: pageType
    }
}
